import {
  type IChangePasswordRequest,
  type IConfirmEmailAndActivateAccountRequest,
  type IForgotPasswordRequest,
  type ILogInAndJoinToCourseRequest,
  type ILogInAndJoinToCourseResponse,
  type ILogInOrSignUpViaGoogleRequest,
  type ILogInOrSignUpViaLinkedInRequest,
  type ILogInRequest,
  type IRegisterAndJoinToCourseRequest,
  type IRegisterAndJoinToCourseResponse,
  type IRegisterRequest,
  type IResetPasswordRequest
} from '@libs/models';

import { BaseApi, type Result } from './api-client';

export class AuthApi extends BaseApi {
  protected readonly baseUrl = '/api/auth';

  async login(request: ILogInRequest): Promise<void> {
    return this.postVoid('/login', request);
  }

  async register(request: IRegisterRequest): Promise<void> {
    const requestWithOrigin = {
      ...request,
      origin: window.location.origin + import.meta.env.BASE_URL
    };
    return this.postVoid('/register', requestWithOrigin);
  }

  async logout(): Promise<void> {
    return this.postVoid('/logout');
  }

  async confirmEmailAndActivateAccount(
    request: IConfirmEmailAndActivateAccountRequest
  ): Promise<void> {
    return this.postVoid('/confirmEmailAndActivateAccount', request);
  }

  async forgotPassword(request: IForgotPasswordRequest): Promise<void> {
    const requestWithOrigin = {
      ...request,
      origin: window.location.origin + import.meta.env.BASE_URL
    };
    return this.postVoid('/forgotPassword', requestWithOrigin);
  }

  async resetPassword(request: IResetPasswordRequest): Promise<void> {
    return this.postVoid('/resetPassword', request);
  }

  async changePassword(request: IChangePasswordRequest): Promise<void> {
    return this.postVoid('/changePassword', request);
  }

  async loginOrSignUpViaGoogle(request: ILogInOrSignUpViaGoogleRequest): Promise<void> {
    return this.postVoid('/logInOrSignUpViaGoogle', request);
  }

  async loginOrSignUpViaLinkedIn(request: ILogInOrSignUpViaLinkedInRequest): Promise<void> {
    return this.postVoid('/logInOrSignUpViaLinkedIn', request);
  }

  async getCookie(): Promise<Result<{ isAuthenticated: boolean }>> {
    return this.get<{ isAuthenticated: boolean }>('/cookie', null, 'Get cookie failed');
  }

  async loginAndJoinCourse(
    request: ILogInAndJoinToCourseRequest
  ): Promise<Result<ILogInAndJoinToCourseResponse | null>> {
    return this.post<ILogInAndJoinToCourseResponse | null>(
      '/logInAndJoinToCourse',
      request,
      'Login and join course failed'
    );
  }

  async registerAndJoinCourse(
    request: IRegisterAndJoinToCourseRequest
  ): Promise<Result<IRegisterAndJoinToCourseResponse | null>> {
    const requestWithOrigin = {
      ...request,
      origin: window.location.origin + import.meta.env.BASE_URL
    };
    return this.post<IRegisterAndJoinToCourseResponse | null>(
      '/registerAndJoinToCourse',
      requestWithOrigin,
      'Register and join course failed'
    );
  }
}

export const authApi = new AuthApi();
